import styled, { css } from "styled-components";
import { Theme } from "../../themes/theme";

const variants = {
  primary: css`
    background: ${Theme.color.text.primary};
    color: ${Theme.color.text.inverse};

    &:hover {
      background: ${Theme.color.text.primaryHover};
    }
  `,

  outline: css`
    border: 1px solid ${Theme.color.border.red};
    color: ${Theme.color.text.primary};
    background-color: ${Theme.color.surface.light};

    &:hover {
      background: ${Theme.color.background.light};
    }
  `,
};

const Wrapper = styled.button`
  border: none;
  width: fit-content;
  padding: 12px 32px;
  text-transform: uppercase;
  font-size: ${Theme.font.fontSize.base};
  font-weight: ${Theme.font.fontWeight.medium};
  border-radius: ${Theme.border.borderRadius.md};
  letter-spacing: ${Theme.font.letterSpacing.wide};
  cursor: pointer;
  transition: 0.15s ease;
  display: flex;
  align-items: center;
  gap: 10px;

  ${({ variant }) => variants[variant] || variants.primary}
  &:hover {
    transform: translateY(-1px);
  }
`;

function PrimaryButton({ children, onClick, variant = "primary" }) {
  return (
    <Wrapper variant={variant} onClick={onClick}>
      {children}
    </Wrapper>
  );
}

export default PrimaryButton;
